import { Paper, Stack } from '@mui/material'
import { ReceiptAdminDto, ReceiptClientDto } from 'service-api/src/types'
import { CheckInOut, DetailsSection, Footer, Header, OffersSection } from './receipt_details'
import { useTheme } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'

export const PurchaseReceipt = ({
  receipt,
  dueToday,
}: {
  receipt?: ReceiptClientDto | ReceiptAdminDto
  dueToday?: number | null
}) => {
  const theme = useTheme()
  const isBelowMD = useMediaQuery(theme.breakpoints.down('md'))

  return receipt ? (
    <Paper sx={{ p: 2, height: '100%', borderRadius: `${isBelowMD ? 0 : theme.shape.borderRadius}px` }}>
      <Header name={receipt.locationName} address={receipt.locationAddress} phone={receipt.locationPhone} />
      <CheckInOut checkIn={receipt.checkIn} checkOut={receipt.checkOut} />
      <DetailsSection receipt={receipt} />
      <Stack px={1}>
        <OffersSection receipt={receipt} />
        <Footer receipt={receipt} dueToday={dueToday} />
      </Stack>
    </Paper>
  ) : null
}
